var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo--domuneo",attrs:{"alt":"Domuneo","src":require("@/assets/images/tenants/domuneo/logoWithText.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }